// extracted by mini-css-extract-plugin
export default {"sort":"SortArrow_sort__bJYJ+","asc":"SortArrow_asc__BJ8yG","desc":"SortArrow_desc__kU-E-"};